import { render } from "./OAuthAuthorize.vue?vue&type=template&id=3dc24a78&scoped=true"
import script from "./OAuthAuthorize.vue?vue&type=script&lang=js"
export * from "./OAuthAuthorize.vue?vue&type=script&lang=js"

import "./oauth-authorize.scss?vue&type=style&index=0&id=3dc24a78&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc24a78"]])

export default __exports__